import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../helpers/axiosInstance";

interface eventHoursInitialState {
  updatedHoursResponse: {};
}

const initialState: eventHoursInitialState = {
  updatedHoursResponse: {},
};

const UpdateEventHoursSlice = createSlice({
  name: "updateEventHours",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(postUpdatedUsersEventHours.fulfilled, (state, action) => {
      state.updatedHoursResponse = action.payload;
    });
  },
});

export default UpdateEventHoursSlice.reducer;

export const postUpdatedUsersEventHours = createAsyncThunk(
  "viewUsers/checkedInUsers",
  async (data: object) => {
    const response = await axiosInstance.put(
      `api/events/updateVolunteersHours`,
      data
    );
    return response.data;
  }
);
